import { atom } from 'jotai';
import { atomWithStorage, createJSONStorage } from 'jotai/utils';

import { PowerOfAttorneyFormValues, PowerOfAttorneyS3Keys } from '@/lib/types/power-of-attorney.ts';

const POWER_OF_ATTORNEY_FORM_VALUES_STORAGE_KEY = 'power_of_attorney_form_values';
const POWER_OF_ATTORNEY_S3_KEYS = 'power_of_attorney_s3_keys';

export const INITIAL_POWER_OF_ATTORNEY_FORM_VALUES: PowerOfAttorneyFormValues = {
  principalName: '',
  principalRrn: '',
  principalAddress: '',
  issuedDate: '',
  autographDataUrl: '',
  signedAt: '',
  isReady: false
};

export const autographAtom = atom<string>('');

export const poaFormValuesAtom = atomWithStorage<PowerOfAttorneyFormValues>(
  POWER_OF_ATTORNEY_FORM_VALUES_STORAGE_KEY,
  INITIAL_POWER_OF_ATTORNEY_FORM_VALUES,
  createJSONStorage<PowerOfAttorneyFormValues>(() => sessionStorage)
);

export const poaSaveResultAtom = atomWithStorage<PowerOfAttorneyS3Keys>(
  POWER_OF_ATTORNEY_S3_KEYS,
  { autographImageKey: '', delegationFileKey: '' },
  createJSONStorage<PowerOfAttorneyS3Keys>(() => sessionStorage)
);
